export const WORKER_FILE_NAME = 'worker.5420dc654ae1247ccdca.js';
